import { useEffect } from "react";
import { fetchPrestationsByReservationId } from "../../store/slices/rendezVousSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Prestation from "../../components/prestation";
import { Helmet, HelmetProvider } from "react-helmet-async";

const PrestationsConfirmBloc = ({ buttonAction }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { otherPrestas } = useSelector((state) => state.rendezvous);
  // console.log({otherPrestas})
  useEffect(() => {
    // Fetch reservation when component mounts or id changes
    dispatch(fetchPrestationsByReservationId(id));
  }, [dispatch, id]);

  return (
    <>

      {(otherPrestas?.status === "succeeded" && otherPrestas?.prestations?.length>0) && (
        <>
          <h3 className="grey500">
            Prestations qui pourraient vous intéresser
          </h3>
          <div className="mt-24">
            {otherPrestas?.prestations.map((prestation, key) => (
              <Prestation
                prestation={prestation}
                key={key}
                className="p-16 mt-8 radius8"
                selected={false}
                classNameBtn="twyny-cta-secondary"
                buttonAction={() => buttonAction(prestation)}
                buttonName={"Choisir"}
              />
            ))}
          </div>
        </>
      )}
    </>
  );
};
export default PrestationsConfirmBloc;
